<template>
  <div :id="'aipost-container'" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.6)" :class="placeFooter ? 'aipost-footer' : ''">
    <div class="aipost-main">
      <div v-if="!placeFooter" class="post-row" style="height: 65px;">
        <div class="align-center size16" style="width: 100%;">
          <span class="size16" style="width: 100%;height: 32px;line-height: 32px;font-weight: bold;">
            {{ aipost.name }}
          </span>
          <span v-show="aipost.desc" class="size12 color-66" style="width: 100%;height: 24px;line-height: 24px;margin-left: 10px;">
            <br>
            {{ aipost.desc }}
          </span>
        </div>
      </div>
      <div v-if="aipost.uploadType != 'views' && aipost.uploadType != 'front_image' && aipost.uploadType != 'model' && aipost.uploadType != 'vox'" class="post-row" style="height: 98px;">
        <div style="width:100%;" class="bg-28 round4">
          <div v-if="aipost.uploadType == 'image' || aipost.uploadType == 'image_only'" class="float-left" style="padding: 4px 6px 4px 0;">
            <div v-if="files.image" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
              <div class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-22)'}">
                <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files.image.url" />
              </div>
              <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile('image')" /></div>
            </div>
            <div v-if="!files.image" class="padding4 float-left">
              <div class="round4 padding-top10 bg-22 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles('image')"><span :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px', 'padding-top': '6px'}">+</span><br><span class="size12">{{ aipost.uploadType == 'views' ? $t('i.uploadFrontImg') : $t('i.uploadImg') }}</span></div>
            </div>
          </div>
          <div v-if="aipost.uploadType !== 'image_only'" class="float-right" style="padding-top: 2px;" :style="{'width': aipost.uploadType == 'image' ? 'calc(100% - 90px)' : '100%'}">
            <el-input v-show="showPromptTextArea" v-model="aipost.prompt" type="textarea" class="post-input prompt-input" maxlength="120" :rows="3" resize="false" :placeholder="placeholder" />
            <div v-show="!showPromptTextArea" class="color-66" style="width: 100%;margin-left: 10px;margin-top: 6px;">
              {{ $t('i.noPrompt') }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="aipost.uploadType == 'views' || aipost.uploadType == 'model' || aipost.uploadType == 'front_image' || aipost.uploadType == 'vox'" class="post-row" style="height: 98px;">
        <div style="width:100%;padding: 4px 4px 4px 0;" class="bg-28 round4">
          <div v-if="files.image && (aipost.uploadType == 'views' || aipost.uploadType == 'front_image' || aipost.uploadType == 'image' || aipost.uploadType == 'image_only')" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
            <div class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-22)'}">
              <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files.image.url" />
            </div>
            <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile('image')" /></div>
          </div>
          <div v-if="!files.image && (aipost.uploadType == 'views' || aipost.uploadType == 'front_image' || aipost.uploadType == 'image' || aipost.uploadType == 'image_only')" class="padding4 float-left">
            <div class="round4 padding-top10 bg-22 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles('image')"><span :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px', 'padding-top': '6px'}">+</span><br><span class="size12">{{ aipost.uploadType == 'views' ? $t('i.uploadFrontImg') : $t('i.uploadImg') }}</span></div>
          </div>
          <div v-if="files.back_image && aipost.uploadType == 'views'" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
            <div class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-22)'}">
              <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files.back_image.url" />
            </div>
            <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile('back_image')" /></div>
          </div>
          <div v-if="!files.back_image && aipost.uploadType == 'views'" class="padding4 float-left">
            <div class="round4 padding-top10 bg-22 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles('back_image')"><span :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px'}">+</span><br><span class="size12">{{ $t('i.uploadBackImg') }}</span></div>
          </div>
          <div v-if="files.left_image && aipost.uploadType == 'views'" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
            <div class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-22)'}">
              <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files.left_image.url" />
            </div>
            <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile('left_image')" /></div>
          </div>
          <div v-if="!files.left_image && aipost.uploadType == 'views'" class="padding4 float-left">
            <div class="round4 padding-top10 bg-22 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles('left_image')"><span :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px'}">+</span><br><span class="size12">{{ $t('i.uploadLeftImg') }}</span></div>
          </div>
          <div v-if="files.right_image && aipost.uploadType == 'views'" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
            <div class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-22)'}">
              <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files.right_image.url" />
            </div>
            <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile('right_image')" /></div>
          </div>
          <div v-if="!files.right_image && aipost.uploadType == 'views'" class="padding4 float-left">
            <div class="round4 padding-top10 bg-22 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles('right_image')"><span :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px'}">+</span><br><span class="size12">{{ $t('i.uploadRightImg') }}</span></div>
          </div>
          <div v-if="files.model && aipost.uploadType == 'model'" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
            <div v-if="files.model_image" class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-22)'}">
              <el-image class="round4" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" fit="cover" :src="files.model_image.url" />
            </div>
            <div v-else class="round4 align-center padding-top8" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-22)'}">
              <i class="iconfont my-d3s color-cc" style="font-size: 36px;" />
            </div>
            <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile('model')" /></div>
          </div>
          <div v-if="!files.model && aipost.uploadType == 'model'" class="padding4 float-left">
            <div class="round4 padding-top10 bg-22 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles('model')"><span :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px'}">+</span><br><span class="size12">{{ $t('i.uploadModel') }}</span></div>
          </div>
          <div v-if="files.vox && aipost.uploadType == 'vox'" class="padding4 float-left" :style="{'min-width': thumbSize + 8 + 'px', 'height': thumbSize + 8 + 'px'}">
            <div class="round4 align-center padding-top8" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px', 'background-color': 'var(--color-22)'}">
              <i class="iconfont my-vox color-cc" style="font-size: 36px;" />
            </div>
            <div class="opacity-bg align-center" :style="{'width': thumbSize + 'px', 'height':'24px', 'line-height':'24px', 'position': 'relative', 'top':'-24px'}"><i class="iconfont my-delete size16 white" @click="delFile('vox')" /></div>
          </div>
          <div v-if="!files.vox && aipost.uploadType == 'vox'" class="padding4 float-left">
            <div class="round4 padding-top10 bg-22 color-cc align-center" :style="{'width': thumbSize + 'px', 'height': thumbSize + 'px'}" @click="openFiles('vox')"><span :style="{'font-size': thumbSize * 0.6 + 'px', 'line-height': thumbSize * 0.4 + 'px'}">+</span><br><span class="size12">{{ $t('i.uploadVox') }}</span></div>
          </div>
        </div>
      </div>
      <div class="post-row" style="height: 55px;">
        <div class="float-left" style="width: 100%;">
          <el-dropdown trigger="click" placement="bottom-start" @command="selectType">
            <el-button type="text" :icon="'iconfont ' + aipost.icon" class="align-left margin-right4 select-btn"> {{ aipost.name }} <i class="float-right el-icon-arrow-down el-icon--right" style="margin: 2px 8px 0 0;" /></el-button>
            <el-dropdown-menu slot="dropdown" class="my-dropdown select">
              <el-dropdown-item v-for="type in aipost.types" :key="type.value" :command="type.value"><i :class="'iconfont ' + type.icon" />{{ type.name }} <i v-if="aipost.type === type.value" class="float-right el-icon-check margin-top12" /></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown trigger="click" placement="bottom-start" @command="selectSubtype">
            <el-button v-show="aipost.type !== 'image'" type="text" :icon="'iconfont'" class="align-left short-select-btn"> {{ aipost.subname }} <i class="float-right el-icon-arrow-down el-icon--right" style="margin: 2px 8px 0 0;" /></el-button>
            <el-dropdown-menu slot="dropdown" class="my-dropdown select">
              <el-dropdown-item v-for="type in aipost.subtypes[aipost.type]" :key="type.value" :command="type.value"><i :class="'iconfont ' + type.icon" />{{ type.name }} <i v-if="type.checked" class="float-right el-icon-check margin-top12" /></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-if="aipost.type === 'voxel'" trigger="click" placement="bottom-start" @command="selectOpts">
            <el-button type="text" :icon="'iconfont my-set-up'" class="min-btn margin-left4" />
            <el-dropdown-menu slot="dropdown" class="my-dropdown select min">
              <!-- <el-dropdown-item v-for="voxType in aipost.voxTypes" :key="voxType.value" :command="['voxType', voxType]"><i :class="'iconfont ' + voxType.icon" />{{ voxType.name }} <i v-if="voxType.checked" class="float-right el-icon-check margin-top12" /></el-dropdown-item> -->
              <el-dropdown-item v-for="size in aipost.sizes" :key="size.value" :command="['size', size]">{{ size.name }} <i v-if="aipost.size == size.value" class="float-right el-icon-check margin-top12" /></el-dropdown-item>
              <el-dropdown-item :command="['denoise', 2]" divided>{{ $t('i.optimizeColors') }} <i v-if="aipost.denoise === 2" class="float-right el-icon-check margin-top12" /></el-dropdown-item>
              <!-- <el-dropdown-item :command="['denoise', 1]">{{ $t('i.denoise1') }} <i v-if="aipost.denoise === 1" class="float-right el-icon-check margin-top12" /></el-dropdown-item> -->
              <el-dropdown-item :command="['denoise', 0]">{{ $t('i.denoise0') }} <i v-if="aipost.denoise === 0" class="float-right el-icon-check margin-top12" /></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="float-right">
          <el-button type="text" :icon="'iconfont my-up2'" class="tap-btn" :disabled="!commitEnable" :class="{'bg-blue': commitEnable}" @click="commit" />
        </div>
      </div>
      <div v-if="aipost.uploadType != 'views' && aipost.uploadType != 'model' && aipost.uploadType != 'front_image' && aipost.uploadType != 'vox'" style="width: 100%;text-align:right;position: relative;padding-right:12px;top:-89px;" class="color-99 size12">
        <div v-if="aipost.prompt" class="float-right round4 bg-28" style="padding: 1px 8px;line-height:22px;">{{ txtCount }}</div>
      </div>
      <input ref="ai-uploader" :multiple="false" type="file" :accept="acceptExtends" style="display:none;" @change="selectFiles">
    </div>
  </div>
</template>
<script>
import { mixins } from '@/mixins/common'
import d3Image from '@/assets/d3.png'
import voxImage from '@/assets/d3.png'
import md5 from 'js-md5'
import GRIDY from '@/js/sdk/GridySDK'
// eslint-disable-next-line
import COSSDK from '@/js/sdk/cosSDK'
// eslint-disable-next-line
import conf from '@/js/conf/conf'
import service from '@/js/service'
import utils from '@/js/utils'
export default {
  components: {},
  mixins: [mixins],
  data() {
    const data = {
      loading: false,
      reqing: false,
      fileType: '',
      thumbSize: 75,
      files: {
        vox: '',
        model_image: '',
        model: '',
        image: '',
        left_image: '',
        right_image: '',
        back_image: ''
      },
      aipost: {
        prompt: '',
        resolution: '1024:1024',
        // scale 有参考图片时 文本描述影响的程度，该值越大代表文本描述影响程度越大，且输入图片影响程度越小
        scale: '0.5',
        type: 'voxel',
        denoise: 2,
        maxColors: 32,
        mergerFactor: 32,
        name: this.$t('i.type_voxel'),
        desc: '',
        uploadType: '',
        icon: 'my-brickfy',
        types: [
          { name: this.$t('i.type_voxel'), value: 'voxel', icon: 'my-vox', desc: this.$t('i.type_voxel_desc') },
          // { name: this.$t('i.type_d3'), value: 'd3', icon: 'my-d3s', desc: this.$t('i.type_d3_desc') },
          { name: this.$t('i.type_image'), value: 'image', icon: 'my-gridsfy', desc: this.$t('i.type_image_desc') }
        ],
        subtype: 'pixel',
        subname: this.$t('i.type_pixel'),
        subtypes: {
          voxel: [
            { name: this.$t('i.type_txt2vox'), value: 'txt2vox', checked: true },
            // { name: this.$t('i.type_img2vox'), value: 'img2vox', checked: false, uploadType: 'front_image' },
            { name: this.$t('i.type_views2vox'), value: 'views2vox', checked: false, uploadType: 'views' },
            { name: this.$t('i.type_model2vox'), value: 'model2vox', checked: false, uploadType: 'model' }
            // TODO: 服务端未实现
            // { name: '上传体素模型', value: 'uploadVox', checked: false, uploadType: 'vox' }
          ],
          d3: [
            { name: this.$t('i.type_txt2d3'), value: 'txt2d3', checked: true },
            // { name: this.$t('i.type_img2d3'), value: 'img2d3', checked: false, uploadType: 'front_image' },
            { name: this.$t('i.type_views2d3'), value: 'views2d3', checked: false, uploadType: 'views' }
          ],
          image: [
            { name: this.$t('i.type_volc'), value: 'volc', checked: true, uploadType: 'image' }
            // { name: this.$t('i.type_pixel'), value: 'pixel', checked: false, uploadType: 'image' },
            // { name: this.$t('i.type_views'), value: 'views', checked: false, uploadType: 'image' },
            // { name: this.$t('i.type_plush'), value: 'plush', checked: false, uploadType: 'image' }
          ]
        },
        size: '80',
        sizes: [
          { name: this.$t('i.size_xbig'), value: '128' },
          { name: this.$t('i.size_big'), value: '80' },
          { name: this.$t('i.size_medium'), value: '64' },
          { name: this.$t('i.size_small'), value: '48' }
        ],
        voxTypes: [
          { name: this.$t('i.type_vox'), value: 'vox', icon: 'my-vox', checked: true },
          { name: this.$t('i.type_chain_brick'), value: 'chain_brick', icon: 'my-brickfy', checked: true },
          { name: this.$t('i.type_lego_brick'), value: 'lego_brick', icon: 'my-brick', checked: true }
        ]
      },
      promptLength: 512,
      placeholder: this.$t('i.aipost_placeholder')
    }
    data.voxImage = voxImage
    data.d3Image = d3Image
    data.COSSDK = null
    data.GRIDY = null
    // 图片单边分辨率要求不小于128，不大于5000。大小不超过8m
    data.maxImageWidth = 1024 * 2
    data.maxImageHeight = 1024 * 2
    return data
  },
  computed: {
    placeFooter() {
      return this.mod === 'aiart-aipost'
    },
    isDesktop() {
      return this.state.platform.type === 'desktop'
    },
    showPromptTextArea() {
      return ((['pixel', 'views', 'plush'].indexOf(this.aipost.subtype) > -1 && !this.files.image) || ['pixel', 'views', 'plush'].indexOf(this.aipost.subtype) === -1)
    },
    commitEnable() {
      if (this.aipost.type === 'voxel' || this.aipost.type === 'd3') {
        if (this.aipost.uploadType === 'vox') {
          return !!this.files.vox
        } if (this.aipost.uploadType === 'model') {
          return !!this.files.model
        } else if (this.aipost.uploadType === 'views') {
          return !!(this.files.image || this.files.left_image || this.files.right_image || this.files.back_image)
        } else if (this.aipost.uploadType === 'front_image') {
          return !!this.files.image
        } else {
          return this.aipost.prompt
        }
      } else if (this.aipost.type === 'image') {
        return !!(this.aipost.prompt || this.files.image)
      } else if (this.aipost.uploadType === 'image_only') {
        return !!this.files.image
      }
      return false
    },
    txtCount() {
      return (this.promptLength * 2 - utils.strLength(this.aipost.prompt)) + '/' + this.promptLength * 2
    },
    maxFilesize() {
      if (this.loginUserId < 10000) {
        return 1024 * 1024 * 128
      }
      return 1024 * 1024 * 64
    },
    acceptExtends() {
      if (this.aipost.uploadType === 'model') {
        // 支持： .glb,.obj,.stl
        return '.glb'
        // return '.glb,.obj,.stl'
      } else if (this.aipost.uploadType === 'vox') {
        return '.vox'
      } else {
        // 支持： jpg，png，jpeg，webp
        return '.jpg,.jpeg,.png,.webp'
      }
    }
  },
  watch: {
    'aipost.prompt': {
      handler() {
        if (utils.strLength(this.aipost.prompt) > this.promptLength) {
          this.aipost.prompt = utils.getString(this.aipost.prompt, this.promptLength)
        }
      }
    }
  },
  mounted() {
    this.selectType(this.aipost.type)
  },
  methods: {
    /**
    // origin 来源；0=文生图; 1=图生图; 2=文生3D; 3=图生3D; 4=文生体素; 5=图生体素; 6=3D转体素;
    // 文生积木模型: txt2bloky, 图生积木模型: img2bloky,三视图生积木: views2bloky,3D模型生积木: model2bloky,体素生积木: vox2bloky,
    // 文生体素模型: txt2vox, 图生体素模型: img2vox, 三视图生体素: views2vox, 3D模型生体素: model2vox, 上传体素模型: uploadVox,
    // 文生3D模型: txt2d3,图生3D模型: img2d3, 三视图生3D: views2d3, 生成像素艺术: pixel, 生成IP三视图: views, 生成毛绒玩具: plush, 即梦引擎: volc
    // ai_platform
    // 0=无; 1=腾讯混元生文; 2=腾讯混元文生图; 3=腾讯混元图生图; 4=腾讯混元生视频; 5=腾讯混元生3D;
    // 11=豆包大模型; 12=即梦文生图; 13=即梦图生图; 14=即梦生视频;
    // 21=liblib文生图; 22=liblib文生三视图; 23=liblib图生三视图; 24=liblib图转像素画; 25=liblib图生毛绒玩具;
    // 90=百乐酷3D转体素; 91=百乐酷vox转体素;
      {
      "AIPlatform": 24,
      "Bloky": 0,
      "ChainBrick": 0,
      "LegoBrick": 0,
      "Resolution": "1024:1024",
      "ReqKey": "img2PixelArt",
      "ImageUrl": "cos://image/000/00/00/01/11ae619c7d8ee0bdb3b920044e13aa66.png",
      "Origin": 1
    }
    */
    reEdit(item) {
      const data = item.ai_params || {}
      if (data.Origin === 0 || data.Origin === 1) {
        this.selectType('image')
        if (data.AIPlatform === 12 || data.AIPlatform === 13) {
          this.selectSubtype('volc')
        } else if (data.AIPlatform === 23) {
          this.selectSubtype('views')
        } else if (data.AIPlatform === 24) {
          this.selectSubtype('pixel')
        } else if (data.AIPlatform === 25) {
          this.selectSubtype('plush')
        }
      }
      if (data.AIPlatform === 5) {
        if (data.Bloky) {
          this.selectType('voxel')
        } else {
          this.selectType('d3')
        }
        if (data.Origin === 2) {
          this.selectSubtype('txt2d3')
        } else if (data.Origin === 3) {
          if (data.MultiViewImages && data.MultiViewImages.length) {
            this.selectSubtype('views2d3')
          } else {
            this.selectSubtype('img2d3')
          }
        } else if (data.Origin === 4) {
          this.selectSubtype('txt2vox')
        } else if (data.Origin === 5) {
          if (data.MultiViewImages && data.MultiViewImages.length) {
            this.selectSubtype('views2vox')
          } else {
            this.selectSubtype('img2vox')
          }
        }
      } else if (data.AIPlatform === 90) {
        this.selectType('voxel')
        this.selectSubtype('model2vox')
      }
      this.aipost.prompt = data.Prompt || ''
      if (data.ImageUrl) this.files.image = { url: service.getCosUrl(data.ImageUrl, 'paint', '', true) }
      if (data.MultiViewImages && data.MultiViewImages.length) {
        for (const i in data.MultiViewImages) {
          if (data.MultiViewImages[i].ViewImageUrl) this.files[data.MultiViewImages[i].ViewType + '_image'] = { url: service.getCosUrl(data.MultiViewImages[i].ViewImageUrl, 'paint', '', true) }
        }
      }
      if (data.D3Url) {
        this.files.model = { url: service.getCosUrl(data.D3Url, 'paint', '', true) }
      } else {
        this.files.model = ''
      }
      if (data.D3ImageUrl) {
        this.files.model_image = { url: service.getCosUrl(data.D3ImageUrl, 'paint', '', true) }
      } else {
        this.files.model_image = ''
      }
      if (data.Size) this.aipost.size = data.Size
      if (typeof data.Denoise !== 'undefined') this.aipost.denoise = data.Denoise
      if (typeof data.MaxColors !== 'undefined') this.aipost.maxColors = data.MaxColors
      // if (typeof data.MergerFactor !== 'undefined') this.aipost.mergerFactor = data.MergerFactor
      this.update()
    },
    rePost(item) {
      this.reEdit(item)
      this.commit()
    },
    quoteIt(type, paintid, asset) {
      // console.log(type, paintid, asset)
      if (asset[0] === 'img') {
        this.selectType('image')
        this.selectSubtype('volc')
        this.files.image = { url: asset[1] }
      } else if (asset[0] === 'd3') {
        this.selectType('voxel')
        this.selectSubtype('model2vox')
        this.files.model = { url: asset[2] }
        this.files.model_image = asset[1] ? { url: asset[1] } : ''
      }
      this.update()
    },
    initPrompt() {
      Object.keys(this.files).forEach((fileType) => {
        this.files[fileType] = ''
      })
      this.aipost.prompt = ''
    },
    delFile(fileType) {
      this.files[fileType] = ''
    },
    openFiles(fileType) {
      this.fileType = fileType
      setTimeout(() => {
        this.$refs['ai-uploader'].click()
      }, 100)
    },
    previewFile(file) {
      // TODO: 预览3D文件
      // 引用3D会自动预览图，但是再选择3D模型时，不会自动预览图，且预览图是用之前的引用图
    },
    selectFiles() {
      if (!this.loginStatus) {
        this.$refs['ai-uploader'].value = ''
        this.emit('login')
        return
      }
      const dom = this.$refs['ai-uploader']
      const localFiles = dom.files
      if (!localFiles.length) {
        return
      }
      const denyFiles = []
      Object.values(localFiles).map((file) => {
        if (this.fileType.indexOf('image') !== -1) {
          this.GRIDY = new GRIDY()
          this.GRIDY.compressImage(file.name, window.URL.createObjectURL(file), (fileObj) => {
            file.width = fileObj.width
            file.height = fileObj.height
            file.ext = fileObj.ext
            file.mime = fileObj.mime
            file.quality = fileObj.quality
            file.md5 = md5(fileObj.base64)
            file.url = fileObj.base64
            this.files[this.fileType] = file
            this.$refs['ai-uploader'].value = ''
          }, this.maxImageWidth, this.maxImageHeight, 'file')
        } else {
          if (file.size > this.maxFilesize) {
            denyFiles.push(file.name)
          } else {
            this.files[this.fileType] = file
            this.previewFile(file)
          }
          this.$refs['ai-uploader'].value = ''
        }
      })
      if (denyFiles.length) {
        this.alert(denyFiles.join('、') + ' ' + this.$t('i.maxFilesize', { count: utils.formateBytes(this.maxFilesize) }))
      }
    },
    selectSubtype(subtype) {
      for (const i in this.aipost.subtypes[this.aipost.type]) {
        if (this.aipost.subtypes[this.aipost.type][i].value === subtype) {
          this.setSubtype(this.aipost.type, i)
          break
        }
      }
    },
    setSubtype(type, idx = 0) {
      if (!this.aipost.subtypes[type]) return
      for (const i in this.aipost.subtypes[type]) {
        this.aipost.subtypes[type][i].checked = false
      }
      this.aipost.subtype = this.aipost.subtypes[type][idx].value
      this.aipost.subname = this.aipost.subtypes[type][idx].name
      this.aipost.uploadType = this.aipost.subtypes[type][idx].uploadType || ''
      this.aipost.subtypes[type][idx].checked = true
    },
    selectType(type) {
      this.aipost.type = type
      for (const i in this.aipost.types) {
        if (this.aipost.types[i].value === type) {
          this.aipost.name = this.aipost.types[i].name
          this.aipost.desc = this.aipost.types[i].desc
          this.aipost.icon = this.aipost.types[i].icon
          this.aipost.types[i].checked = true
        } else {
          this.aipost.types[i].checked = false
        }
      }
      this.setSubtype(type, 0)
    },
    selectOpts(cmd) {
      const [type, opt] = cmd
      if (type === 'size') {
        this.aipost.size = opt.value
      } else if (type === 'voxType') {
        opt.checked = !opt.checked
      } else if (type === 'denoise') {
        this.aipost.denoise = opt
      } else if (type === 'maxColors') {
        this.aipost.maxColors = opt
      } else if (type === 'mergerFactor') {
        this.aipost.mergerFactor = opt
      }
    },
    linkTo(link) {
      if (utils.isUrl(link)) {
        window.open(link)
      } else {
        link = utils.jsonParse(link)
        if (link.mod) this.emit('goto', [link.mod, link.dt || {}])
      }
    },
    /**
      // origin 来源；0=文生图; 1=图生图; 2=文生3D; 3=图生3D; 4=文生体素; 5=图生体素; 6=3D转体素;
      // 文生积木模型: txt2bloky, 图生积木模型: img2bloky,三视图生积木: views2bloky,3D模型生积木: model2bloky,体素生积木: vox2bloky,
      // 文生体素模型: txt2vox, 图生体素模型: img2vox, 三视图生体素: views2vox, 3D模型生体素: model2vox, 上传体素模型: uploadVox,
      // 文生3D模型: txt2d3,图生3D模型: img2d3, 三视图生3D: views2d3, 生成像素艺术: pixel, 生成IP三视图: views, 生成毛绒玩具: plush, 即梦引擎: volc
      // ai_platform
      // 0=无; 1=腾讯混元生文; 2=腾讯混元文生图; 3=腾讯混元图生图; 4=腾讯混元生视频; 5=腾讯混元生3D;
      // 11=豆包大模型; 12=即梦文生图; 13=即梦图生图; 14=即梦生视频;
      // 21=liblib文生图; 22=liblib文生三视图; 23=liblib图生三视图; 24=liblib图转像素画; 25=liblib图生毛绒玩具;
      // 90=百乐酷3D转体素; 91=百乐酷vox转体素;
     */
    commit() {
      this.emit('loading', [true])
      this.makeReqData(this.reqPaint)
    },
    makeReqData(cb) {
      if (!this.loginStatus) {
        this.emit('login')
        return
      }
      let ai_platform = 0
      let bloky = 0
      if (['txt2vox', 'img2vox', 'views2vox'].indexOf(this.aipost.subtype) !== -1) {
        ai_platform = 5
        bloky = 1
      } else if (['txt2d3', 'img2d3', 'views2d3'].indexOf(this.aipost.subtype) !== -1) {
        ai_platform = 5
      } else if (this.aipost.subtype === 'uploadVox') {
        bloky = 1
        ai_platform = 91
      } else if (this.aipost.subtype === 'model2vox') {
        bloky = 1
        ai_platform = 90
      } else if (this.aipost.subtype === 'plush') {
        // 有传图片，用liblib；没图片用volc
        ai_platform = this.files.image ? 25 : 12
      } else if (this.aipost.subtype === 'pixel') {
        ai_platform = this.files.image ? 24 : 12
      } else if (this.aipost.subtype === 'views') {
        ai_platform = this.files.image ? 23 : 12
      } else if (this.aipost.subtype === 'volc') {
        ai_platform = this.files.image ? 13 : 12
      }
      const data = {
        skip_check: 1,
        ai_platform: ai_platform
      }
      if (this.aipost.type === 'voxel' || this.aipost.type === 'd3') {
        data.bloky = bloky
        data.chain_brick = bloky
        data.lego_brick = 0
        data.format = 'GLB'
        data.pdb = 0
        if (this.aipost.subtype === 'txt2vox' || this.aipost.subtype === 'txt2d3') {
          if (!this.aipost.prompt) {
            this.alert(this.$t('i.reqPrompt'))
            cb && cb()
            return
          }
          data.prompt = this.aipost.prompt
        } else if (this.aipost.subtype === 'img2vox' || this.aipost.subtype === 'img2d3') {
          data.prompt = ''
          data.image_url = this.files.image || ''
        } else if (this.aipost.subtype === 'views2vox' || this.aipost.subtype === 'views2d3') {
          data.prompt = ''
          data.image_url = this.files.image || ''
          data.left_image_url = this.files.left_image || ''
          data.right_image_url = this.files.right_image || ''
          data.back_image_url = this.files.back_image || ''
        } else if (this.aipost.subtype === 'model2vox') {
          data.prompt = ''
          data.d3_url = this.files.model || ''
          data.d3_image_url = this.files.model_image || ''
        } else if (this.aipost.subtype === 'uploadVox') {
          data.prompt = ''
          data.vox_url = this.files.vox || ''
        }
        if (this.aipost.size && this.aipost.type === 'voxel') data.size = this.aipost.size
        if (this.aipost.type === 'voxel') {
          data.denoise = this.aipost.denoise
          data.max_colors = this.aipost.maxColors
          data.merger_factor = this.aipost.mergerFactor
        }
      } else if (this.aipost.type === 'image') {
        if (['pixel', 'views', 'plush'].indexOf(this.aipost.subtype) > -1) {
          if (ai_platform === 12) {
            if (!this.aipost.prompt) {
              this.alert(this.$t('i.reqPromptOrImage'))
              cb && cb()
              return
            }
          } else {
            if (this.files.image) {
              data.prompt = ''
            } else {
              this.alert(this.$t('i.reqImage'))
              cb && cb()
              return
            }
          }
        } else {
          if (!this.files.image && !this.aipost.prompt) {
            this.alert(this.$t('i.reqPromptOrImage'))
            cb && cb()
            return
          }
        }
        data.prompt = this.aipost.prompt || ''
        data.image_url = this.files.image || ''
        data.resolution = this.aipost.resolution || '1024:1024'
        data.scale = this.aipost.scale || '0.5'
      }
      let count = 0
      const callback = (type, url) => {
        count--
        if (type) data[type + '_url'] = url || ''
        if (count === 0) {
          cb && cb(data)
        }
      }
      if (data.image_url) {
        count++
        this.upload('image', data.image_url, callback)
      }
      if (data.left_image_url) {
        count++
        this.upload('left_image', data.left_image_url, callback)
      }
      if (data.right_image_url) {
        count++
        this.upload('right_image', data.right_image_url, callback)
      }
      if (data.back_image_url) {
        count++
        this.upload('back_image', data.back_image_url, callback)
      }
      if (data.d3_url) {
        count++
        this.upload('d3', data.d3_url, callback)
      }
      if (data.d3_image_url) {
        count++
        this.upload('d3_image', data.d3_image_url, callback)
      }
      if (data.vox_url) {
        count++
        this.upload('vox', data.vox_url, callback)
      }
      count++
      callback()
    },
    upload(type, fileObj, cb) {
      if (!fileObj) {
        setTimeout(() => {
          cb && cb(type, '')
        }, 100)
        return
      }
      if (fileObj.url) {
        if (fileObj.url.indexOf('public/paint/') >= 0) {
          setTimeout(() => {
            cb && cb(type, service.encodeCosUrl(fileObj.url, 'paint'))
          }, 100)
          return
        }
      }
      const path = 'public/paint/' + type + '/' + utils.calcUserPath(this.loginUserId) + '/'
      let filename = ''
      if (fileObj.md5 && fileObj.ext) {
        filename = fileObj.md5 + '.' + fileObj.ext
      } else {
        filename = md5(fileObj.name + '_' + utils.time('time')) + '.' + fileObj.name.split('.').pop()
        // filename = fileObj.name
      }
      const key = path + filename
      this.emit('traceEvent', ['upload_aipost', '', { type: type }])
      // 上传文件
      this.COSSDK = new COSSDK()
      this.COSSDK.putObject({
        Bucket: conf.cosBucket.bucket,
        Region: conf.cosBucket.region,
        Key: key,
        Body: fileObj
      }, (err, data) => {
        if (!err && data && data.statusCode === 200 && data.Location) {
          const url = 'cos://' + key.replace('public/paint/', '')
          cb && cb(type, url)
        } else {
          this.message(this.$t('i.busy'), 'error')
          cb && cb(type, '')
        }
      })
    },
    reqPaint(data) {
      if (this.reqing) return
      this.reqing = true
      service.post('paint', data, (dt, type) => {
        setTimeout(() => {
          this.reqing = false
        }, 1000)
        if (type === 'success') {
          // this.message(this.$t('i.queueing'), type)
          this.initPrompt()
          service.incCount(this.loginUserId, 'paint')
          // if (dt.data.consumeNums) {
          //   setTimeout(() => {
          //     this.alert(this.$t('i.consumeMoney', { consumeNums: dt.data.consumeNums }))
          //   }, 1000)
          // }
          // 扣除晶钻
          if (dt.data && dt.data.consumeNums) this.emit('consumeSource', [10007, dt.data.consumeNums])
        } else {
          if (type === 'login') {
            this.message(dt, type)
          } else {
            this.alert(dt)
          }
        }
      }, true)
    }
  }
}
</script>
